<template>
  <div :class="{ 'view-quill-wrap': disabled }">
    <div class="quill-box">
      <quillEditor
        id="can-auto-scroll-quill-editor"
        ref="quill"
        class="quill-editor ql-editor quill-editor-component"
        :value="value"
        :disabled="disabled"
        :options="editorOption"
        @focus="isFocus = true"
        @blur="isFocus = false"
        @input="($event) => $emit('input', $event)"
        @change="onEditorChange($event)"
      />
      <div v-if="limitLength" class="limit-text">
        {{ currentlength }} / {{ limitLength }}
      </div>
    </div>

    <file-plugin
      :disabled="currentlength === limitLength"
      disabledTips="输入已达上限，无法继续添加内容"
      v-if="!disabled"
      class="file-plugin"
      @select="selectFile"
      :fileType="'image'"
    ></file-plugin>
  </div>
</template>

<script>
import FilePlugin from "@saas/pages/src/chat/plugin-components/file/index.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    quillEditor,
    FilePlugin,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    dir: {
      type: String,
      default: "",
    },
    limitLength: {
      type: Number,
      default: 0,
    },
    limitImage: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      default: "请输入内容",
    },
    // 图片大小限制 MB
    imageSize: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocus: false,
      type: "image",
      showUploadImgDialog: false,
      editorOption: {
        placeholder: this.placeholder,
        theme: "snow",
        modules: {},
      },
      addRange: null,
      currentlength: 0,
    };
  },
  mounted() {
    if (this.$refs.quill) {
      this.currentlength = this.$refs.quill.quill.getLength() - 1;
    }
  },
  methods: {
    scrollToBottomFocus() {
      const eleEditor = document.querySelector(
        "#can-auto-scroll-quill-editor.quill-editor-component .ql-editor"
      );
      eleEditor.scrollTop = eleEditor.scrollHeight;
      this.$refs.quill.quill.setSelection(this.currentlength + 1);
    },
    selectFile(val) {
      const index = this.getIndex();
      this.$refs.quill.quill.insertEmbed(
        index,
        "image",
        val.file.url + "?imageView2/0/w/500"
      );
      this.$refs.quill.quill.setSelection(index + 1);

      // 出入图片后-自动滚动不生效？
      let { img_height, img_width } = val.file;
      const eleEditor = document.querySelector(
        "#can-auto-scroll-quill-editor.quill-editor-component .ql-editor"
      );
      let maxWidth = eleEditor.clientWidth - 10;
      let imgHeigth = img_height;
      if (img_width > maxWidth) {
        imgHeigth = (img_height * maxWidth) / img_width;
      }
      setTimeout(() => {
        const eleEditor = document.querySelector(
          "#can-auto-scroll-quill-editor.quill-editor-component .ql-editor"
        );
        eleEditor.scrollTop += imgHeigth;
      }, 500);
    },
    // 图片数量是否超出限制
    isLimitNum() {
      const content = this.$refs.quill.quill.getContents();
      const imageList = content.filter(
        (item) => item.insert && item.insert.image
      );
      if (this.limitImage > 0 && imageList.length >= this.limitImage) {
        this.$message.error(`图片数量不能超过${this.limitImage}张`);
        return true;
      } else {
        return false;
      }
    },
    onEditorChange({ quill, html, text }) {
      this.currentlength = this.$refs.quill.quill.getLength() - 1;
      if (this.limitLength && this.currentlength >= this.limitLength) {
        this.$refs.quill.quill.deleteText(this.limitLength, 2000000);
      }
      this.$emit("change");
    },
    confirmSelectFile(val) {
      if (Array.isArray(val)) {
        if (this.type === "image") {
          // 判断图片大小
          if (
            this.imageSize > 0 &&
            val[0]?.file_size &&
            val[0].file_size > this.imageSize * 1024 * 1024
          ) {
            this.$message.error("图片大小不能超过" + this.imageSize + "MB");
            return;
          }
          val.forEach((item) => {
            this.$refs.quill.quill.insertEmbed(
              this.addRange?.index,
              "image",
              item.url
            );
          });
        } else if (this.type === "video") {
          val.forEach((item) => {
            this.$refs.quill.quill.insertEmbed(
              this.addRange?.index,
              "video",
              item.url
            );
          });
        }
      }
    },
    // 获取编辑器光标位置
    getIndex() {
      return this.$refs.quill.quill.selection.savedRange.index; // 获取光标位置
    },
    imgHandler(val) {
      if (this.isLimitNum()) {
        return;
      }
      if (val) {
        this.type = "image";
        this.$refs["selectFile"].showPopup(-1);
        this.addRange = this.$refs.quill.quill.getSelection();
      } else {
        this.$refs.quill.quill.format("image", false);
      }
    },
    videoHandler(val) {
      if (val) {
        this.type = "video";
        this.$refs["selectFile"].showPopup(-1);
        this.addRange = this.$refs.quill.quill.getSelection();
      } else {
        this.$refs.quill.quill.format("video", false);
      }
    },
    // 粘贴拦截
    desMatcherImage(node, Delta) {
      if (this.isFocus) {
        // 赋值粘贴
        Delta.ops = [];
        return Delta;
      } else {
        return Delta;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ql-disabled {
  font-size: 14px !important;
  color: #0d1400 !important;
  line-height: 18px !important;
  padding-bottom: 0 !important;
}
::v-deep .ql-editor {
  padding: 0 !important;
  p {
    margin-bottom: 6px;
  }
  img {
    margin-bottom: 6px;
  }
}
.quill-box {
  position: relative;
  .limit-text {
    width: calc(100% - 2px);
    background: #fff;
    text-align: right;
    position: absolute;
    right: 1px;
    bottom: 1px;
    padding-right: 20px;
    color: var(--el-text-color-secondary);
    border-radius: 8px;
  }
}
.quill-editor-component {
  ::v-deep .ql-container {
    border: none;
    padding-bottom: 25px;
    .ql-editor {
      scroll-behavior: smooth;
      &:hover::-webkit-scrollbar-thumb {
        background: #f2f4f5;
      }
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background: transparent;
        border-radius: 2px;
      }
    }

    &.ql-snow {
      border-color: #e5e6eb;
      border-radius: 0 0 8px 8px;
    }
    .ql-editor {
      padding: 0 10px 0 0 !important;
      &::before {
        font-style: normal;
        left: 0;
      }
      p,
      span,
      div {
        background-color: unset !important;
        word-break: break-all;
        // &::selection {
        //   background: transparent;
        //   color: inherit;
        // }
      }
      img {
        max-width: 100%;
        background-color: unset !important;
        // &::selection {
        //   background: transparent;
        //   color: inherit;
        // }
      }
    }
    // &::-webkit-scrollbar {
    //   width: 4px;
    // }
    // &::-webkit-scrollbar-thumb {
    //   background: transparent;
    //   border-radius: 2px;
    // }
  }
  ::v-deep .ql-toolbar {
    display: none;
  }
}
// 字数提示
::v-deep .quill-box .limit-text {
  width: calc(100% - 5px);
  left: -1px;
  bottom: -2px;
  padding-right: 14px;
  border-radius: 0;
}
.file-plugin {
  margin-top: 10px;
}

// 查看
.view-quill-wrap {
  ::v-deep .quill-box .limit-text {
    display: none;
  }
}
</style>
